<div class="flex-center-space-between padding-1">
  <span class="font-1 bold600"> Accumulated profit and loss </span>
  <app-tabs
    *ngIf="!show.accounts && !show.emptyState"
    data-qa="pl-tabs"
    [tabNamesRaw]="plTabs"
    [selectedIndexTab]="selectedPLTabIndex"
    [isGrey]="true"
    (selectedTabEmitter)="selectedPLTab=$event"
  >
  </app-tabs>
</div>

<!--            PL Table                  -->
<app-empty-state-standard
  *ngIf="show.emptyState"
  [isAdmin]="true"
  [heading]="'No allocated accounts yet.'"
  [buttonText]="'Go to assembly'"
  (buttonClick)="goToAssembly()"
>
</app-empty-state-standard>

<div *ngIf="!show.accounts" class="table-fms">
  <table>
    <colgroup *ngIf="!show.emptyState">
      <col span="1" class="width-2pcnt" />
      <col span="1" class="width-50pcnt" />
      <ng-container *ngIf="selectedPLTab === 'Quarter over quarter'">
        <ng-container *ngFor="let quarterHeader of periodsData.quarterHeaders">
          <col class="width-10pcnt" />
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selectedPLTab === 'Year over year'">
        <ng-container *ngFor="let yearHeader of periodsData.yearHeaders">
          <col class="width-10pcnt" />
        </ng-container>
      </ng-container>
      <col span="1" class="width-0p5pcnt"/>
      <col span="1" class="width-12pcnt" />
    </colgroup>
    <thead *ngIf="!show.emptyState">
    <tr class="text-center">
      <th id="three-dots-menu">
        <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
        <mat-menu class="mat-menu zero-padding" #menu="matMenu">
          <ul class="list">
            <app-drop-down-item
              data-qa="bs-pl-export-excel"
              class="width-100pcnt"
              [iconNameAndStyling]="'excel.svg'"
              [text]="'Export'"
              (click)="exportExcelPl()">
            </app-drop-down-item>
          </ul>
        </mat-menu>
      </th>
      <th class="size-s"></th>
      <ng-container *ngIf="selectedPLTab === 'Quarter over quarter'">
        <ng-container *ngFor="let quarterHeader of periodsData.quarterHeaders">
          <th class="size-m">
            {{ quarterHeader.start }} <br> till {{quarterHeader.end}}
          </th>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selectedPLTab === 'Year over year'">
        <ng-container *ngFor="let yearHeader of periodsData.yearHeaders">
          <th class="size-m">
            {{ yearHeader.start }} <br> till {{yearHeader.end}}
          </th>
        </ng-container>
      </ng-container>
      <th class="blank-space"></th>
      <th class="size-m">
        Inception till <br/> {{ financialStatementPeriod }}
      </th>
    </tr>
    </thead>

    <tbody *ngFor="let part of parts; let i = index">
    <tr *ngIf="part.sums.quarterlySums.size" class="clickable" (click)="closePart(part.partName)">
      <td>
        <app-table-group-icon [opened]="show.parts[part.partName]"></app-table-group-icon>
      </td>
      <!--        colspan is adjusted to show hidden PL quarters columns properly      -->
      <td class="first-level-left-sticky body-header"
          [attr.colspan]="
            (selectedPLTab === 'Quarter over quarter' ? (periodsData.quarters.length > 1 ? 2 : 0)
            : (selectedPLTab === 'Year over year' ? (periodsData.years.length > 1 ? 2 : 0) : 0))">
        <div class="start-row-container row-gap-0p625">
            <span class="light-bold">
              {{ part.partName }}
            </span>
        </div>
      </td>
      <ng-container>
        <td *ngIf="selectedPLTab==='Quarter over quarter' && periodsData.quarters.length>0" [attr.colspan]="periodsData.quarters.length - 1"></td>
        <td *ngIf="selectedPLTab==='Year over year' && periodsData.years.length>0" [attr.colspan]="periodsData.years.length - 1"></td>
        <td class="blank-space"></td>
        <td></td>
      </ng-container>
    </tr>
    <ng-container *ngIf="show.parts[part.partName]">
      <ng-container *ngFor="let item of part.financialStatementItems">
        <tr *ngIf="item.financialStatementAccounts.length" class="text-center">
          <td></td>
          <td
            *ngVar="item.financialStatementAccounts.length as amountOfAccounts"
          >
            <div class="start-row-container row-gap-0p75">
              <div class="start-row-container row-gap-0p25">
                <div
                  appShortenWithoutHover="30" [text]="item.name | uppercase">
                </div>
                <app-chain-icon
                  *ngIf="item.assetsAndLiabilities"
                ></app-chain-icon>
              </div>
              <app-button
                *ngIf="amountOfAccounts"
                class="hidden-button-until-hover no-background-button-wrapper"
                [size]="'xsmall'"
                (buttonClick)="showAllocatedAccounts(item)"
                data-qa="pl-item-view-allocated-accounts"
              >
                <div class="start-row-container row-gap-0p25">
                  <span> {{ amountOfAccounts }} account{{amountOfAccounts > 1 ? "s" : "" }} </span>
                  <app-all-icons [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
                </div>
              </app-button>
            </div>
          </td>
          <ng-container *ngIf="selectedPLTab==='Quarter over quarter'">
            <ng-container *ngFor="let quarter of periodsData.quarters">
              <td>
                {{ item.sums.quarterlySums.get(quarter) * (-1) | switcherDashBraces : switcher : 0 }}
              </td>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="selectedPLTab==='Year over year'">
            <ng-container *ngFor="let year of periodsData.years">
              <td>
                {{ item.sums.yearlySums.get(year) * (-1) | switcherDashBraces : switcher : 0 }}
              </td>
            </ng-container>
          </ng-container>
          <td class="blank-space"></td>
          <td class="black-9">
            {{ item.sums.balance * -1 | switcherDashBraces : switcher : 0 }}
          </td>
        </tr>
      </ng-container>
    </ng-container>

    <tr *ngIf="!show.emptyState && part.sums.quarterlySums.size" class="total text-center light-bold">
      <td></td>
      <td class="text-left">Total {{ part.partName }}</td>
      <ng-container *ngIf="selectedPLTab==='Quarter over quarter'">
        <ng-container *ngFor="let quarter of periodsData.quarters">
          <td>
            {{ part.sums.quarterlySums.get(quarter) * -1 | switcherDashBraces : switcher : 0 }}
          </td>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selectedPLTab==='Year over year'">
        <ng-container *ngFor="let year of periodsData.years">
          <td>
            {{ part.sums.yearlySums.get(year) * -1 | switcherDashBraces : switcher : 0 }}
          </td>
        </ng-container>
      </ng-container>
      <td class="blank-space"></td>
      <td class="black-9">
        {{ part.sums.balance * -1 | switcherDashBraces : switcher : 0 }}
      </td>
    </tr>
    </tbody>
    <tbody>
    <tr *ngIf="!show.emptyState" class="total text-center light-bold">
      <td></td>
      <td class="text-left">Net total</td>
      <ng-container *ngIf="selectedPLTab==='Quarter over quarter'">
        <ng-container *ngFor="let quarter of periodsData.quarters">
          <td>
            {{
              (
                (
                  financialStatement.profitLossParts[0].sums.quarterlySums.get(quarter) || 0
                ) +
                (
                  financialStatement.profitLossParts[1].sums.quarterlySums.get(quarter) || 0
                )
              ) * -1
                | switcherDashBraces : switcher : 0}}
          </td>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selectedPLTab==='Year over year'">
        <ng-container *ngFor="let year of periodsData.years">
          <td>
            {{
              (
                (
                  financialStatement.profitLossParts[0].sums.yearlySums.get(year) || 0
                ) +
                (
                  financialStatement.profitLossParts[1].sums.yearlySums.get(year) || 0
                )
              ) * -1
                | switcherDashBraces : switcher : 0}}
          </td>
        </ng-container>
      </ng-container>
      <td class="blank-space"></td>
      <td class="black-9">
        {{
          (financialStatement.profitLossNetTotals.balance / -1 ) | switcherDashBraces : switcher : 0
        }}
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="show.accounts">
  <div class="table-header-button-and-title-wrapper row-gap-0p5 padding-1">
    <div class="start-row-container row-gap-0p5">
      <span
        data-qa="pl-tb-drilldown-exit"
        class="clickable navigation-link start-row-container row-gap-0p5"
        (click)="show.accounts = false; isDrillDownEmitter.emit(false)"
      >
        <span> Profit and loss </span>
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
      </span>
      <span
        *ngIf="trialBalanceComponent"
        data-qa="pl-drilldown-exit-gl-to-tb"
        [ngClass]="{'clickable navigation-link': trialBalanceComponent?.show.glDrilldown}"
        (click)="trialBalanceComponent.show.glDrilldown=false"
      >
        {{ selectedItemForDrilldown?.partName }} - {{ selectedItemForDrilldown?.name | uppercase }}
      </span>
      <ng-container *ngIf="trialBalanceComponent?.show.glDrilldown" >
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
        <span *ngVar="trialBalanceComponent.selectedAccountForDrilldown.glTransactions.length as transactionsAmount">
          {{ trialBalanceComponent.selectedAccountForDrilldown.code }} -
          {{ trialBalanceComponent.selectedAccountForDrilldown.name }} |
          {{ transactionsAmount }}
          {{ transactionsAmount === 1 ? 'entry' : 'entries' }}
        </span>
      </ng-container>
    </div>
    <div class="end-row-container row-gap-0p5">
      <span class="start-row-container row-gap-0p25">
        From:
        <app-input-date
          data-qa="item-drilldown-date-picker"
          #accountFilterForDataDatePicker
          [maxDate]="accountFilterDataForDrilldown.selectedPeriod"
          [isRequired]="true"
          [(input)]="accountFilterDataForDrilldown.selectedDate"
          (inputChange)="drilldownFilterChange(accountFilterDataForDrilldown.selectedPeriod, $event)"
        >
        </app-input-date>
      </span>
      <span class="start-row-container row-gap-0p25">
        Till:
        <app-selector
          data-qa="item-drilldown-period-selector"
          class="font-3 width-11 black-9"
          [data]="accountFilterDataForDrilldown.selectorPeriods"
          [selectedItem]="accountFilterDataForDrilldown.selectedPeriod"
          (itemEmitter)="drilldownFilterChange($event, accountFilterDataForDrilldown.selectedDate)"
        >
        </app-selector>
      </span>
      <app-button
        data-qa="reset-button-account-drilldown-filter"
        [type]="'dark-grey'"
        [size]="'small'"
        (buttonClick)="resetAccountFiltersForDrilldown()"
      >
        Reset
      </app-button>
    </div>
  </div>

  <app-trial-balance
    #itemDrilldown
    class="green-scroll"
    [isDrilldown]="true"
    [isLocked]="financialStatement?.isCompleted || !isAdmin"
    [showTrialBalanceNavBar]="false"
    [tbData]="selectedItemForDrilldown.financialStatementAccounts"
    [accountFilterDataObject]="accountFilterDataForDrilldown"
    (manualAccountEmitter)="manualAccountEmitter.emit($event)"
    (bulkDeleteEmitter)="bulkDeleteAccountsEmitter.emit($event)"
  >
  </app-trial-balance>
</div>
